import React from 'react'
import { useStoreon } from 'storeon/react';
import dayjs from 'dayjs';
import { GxIcon } from '@garpix/garpix-web-components-react'
import RefreshSVG from '@/assets/Base/refresh.svg';
import { Events, State } from '@/interfaces';

import styles from './styles/index.module.scss'

export const ScheduleHeader = () => {
  const {
    dispatch,
    dateFlyingList
  } = useStoreon<State, Events>('dateFlyingList');

  const handleClickRefresh = () => {
    dispatch('flyingList/get', { date: dayjs(dateFlyingList).format('YYYY-MM-DD') })
  }

  return (
    <div className={styles['wrapper']}
    >
      <div className={styles['wrapper--left_block']}>
        <span>Полетный лист</span>
        <div className={styles['refrech-wrapper']} onClick={handleClickRefresh} role='button' tabIndex={0}>
          <GxIcon
            className={styles['refrech-wrapper--icon']}
            src={RefreshSVG}
          />
          <span className={styles['refrech-wrapper--text']}>Обновить таблицу</span>
        </div>
        <div/>
      </div>
    </div>
  )
}
